import { Injectable } from '@angular/core';
import { UserCustomizationsModel } from '@rd/types';
import { Observable } from 'rxjs';
import { NydusNetworkApiDataService } from '../nydus-network-api-data/nydus-network-api-data.service';

@Injectable({
  providedIn: 'root',
})
export class UserCustomizationsApiService {
  constructor(private nydusNetworkApiDataService: NydusNetworkApiDataService) {}

  updateUserCustomizations(
    userCustomizations: UserCustomizationsModel,
  ): Observable<void> {
    return this.nydusNetworkApiDataService.put<void>('user_customizations', {
      user_customizations: {
        ...userCustomizations,
      },
    });
  }

  getUserCustomizations(): Observable<UserCustomizationsModel> {
    return this.nydusNetworkApiDataService.get<UserCustomizationsModel>(
      'user_customizations',
    );
  }
}
